"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
var _reactRedux = require("react-redux");
var _Data = _interopRequireDefault(require("../../pages/Data"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DataBrowser = function DataBrowser(props) {
  var projectId = props.projectId,
    showCustomizeButton = props.showCustomizeButton,
    showVisualizeButton = props.showVisualizeButton,
    showQueriesWithTags = props.showQueriesWithTags,
    showDeploymentIds = props.showDeploymentIds,
    constantFilter = props.constantFilter,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings,
    overrideVisualizeDeploymentLabels = props.overrideVisualizeDeploymentLabels,
    applyPawnContext = props.applyPawnContext,
    adjustColumns = props.adjustColumns,
    renders = props.renders,
    showVisualizeSettings = props.showVisualizeSettings,
    noDeploymentsMessage = props.noDeploymentsMessage;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var projectList = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.projectList;
  });
  var currentProjectId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentProjectId;
  });
  var currentProjectVisibleDeploymentIds = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin2.getCurrentProjectVisibleDeploymentIds)(state.assignment.admin);
  });
  var hasProject = projectList.some(function (project) {
    return project.groupId === projectId;
  });
  (0, _react.useEffect)(function () {
    var loadProjects = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var promises;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              promises = [dispatch((0, _admin.loadProjectList)()), dispatch((0, _admin.loadDevTags)())];
              _context.n = 1;
              return Promise.all(promises);
            case 1:
              setLoading(false);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadProjects() {
        return _ref.apply(this, arguments);
      };
    }();
    dispatch((0, _admin.resetState)());
    if (showQueriesWithTags) {
      dispatch((0, _admin.setQueryTagFilter)(showQueriesWithTags));
    }
    loadProjects();
    return function () {
      return dispatch((0, _admin.resetState)());
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!hasProject) {
      return;
    }
    if (showDeploymentIds) {
      dispatch((0, _admin.setVisibleDeploymentIds)(showDeploymentIds));
    }
    dispatch((0, _admin.loadProject)(projectId, showDeploymentIds));
    return function () {
      dispatch((0, _admin.clearVisibleDeploymentIds)());
    };
  }, [hasProject, projectId, showDeploymentIds]);
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  if (!hasProject) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "There is no project with selected groupId");
  }
  if (currentProjectId !== projectId) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  if (currentProjectVisibleDeploymentIds.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", null, noDeploymentsMessage !== null && noDeploymentsMessage !== void 0 ? noDeploymentsMessage : 'There are no deployments to show');
  }
  return /*#__PURE__*/_react["default"].createElement(_Data["default"], {
    hideProjectDropdown: true,
    showCustomizeButton: showCustomizeButton,
    showVisualizeButton: showVisualizeButton,
    constantFilter: constantFilter,
    showSaveButton: false,
    overrideInitialVisualizeSettings: overrideInitialVisualizeSettings,
    overrideVisualizeDeploymentLabels: overrideVisualizeDeploymentLabels,
    applyPawnContext: applyPawnContext,
    adjustColumns: adjustColumns,
    renders: renders,
    saveQueryInUrl: false,
    showVisualizeSettings: showVisualizeSettings
  });
};
DataBrowser.propTypes = {
  projectId: _propTypes["default"].number.isRequired,
  showCustomizeButton: _propTypes["default"].bool,
  showVisualizeButton: _propTypes["default"].bool,
  showQueriesWithTags: _propTypes["default"].array,
  showDeploymentIds: _propTypes["default"].array,
  constantFilter: _propTypes["default"].object,
  overrideInitialVisualizeSettings: _propTypes["default"].object,
  overrideVisualizeDeploymentLabels: _propTypes["default"].object,
  applyPawnContext: _propTypes["default"].bool,
  showVisualizeSettings: _propTypes["default"].bool,
  // function to adjust table columns
  // called like this: adjustColumns({ columns, currentQuerySettings })
  adjustColumns: _propTypes["default"].func,
  renders: _propTypes["default"].object,
  noDeploymentsMessage: _propTypes["default"].string
};
DataBrowser.defaultProps = {
  showCustomizeButton: true,
  showVisualizeButton: true,
  overrideInitialVisualizeSettings: {}
};
var _default = exports["default"] = DataBrowser;